var _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHierarchy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "hierarchy_svg__icon hierarchy_svg__icon-tabler hierarchy_svg__icon-tabler-hierarchy",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 5,
  r: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 19,
  r: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 17.5 12 13l5.5 4.5M12 7v6"
})));
export default SvgHierarchy;